/**
 * @file Main entry point for the @crescender/calendar library.
 * 
 * This library is structured with separate client and server modules:
 * 
 * - `/client` - Browser-safe, zero Node.js dependencies
 * - `/server` - Node.js only, for API routes and database operations  
 * - `/shared` - Common types & utilities for both environments
 * 
 * The main entry point only exports shared functionality to maintain clean separation.
 * 
 * Usage examples:
 * 
 * ```typescript
 * // For client-side (React, Vue, etc.)
 * import { EventCard, validateEvent, formatDateAustralian } from '@crescender/calendar/client';
 * 
 * // For server-side (API routes, Node.js)
 * import { initDb, createEvent, generateIcs } from '@crescender/calendar/server';
 * 
 * // For shared utilities (both environments)
 * import { EVENT_TYPES, PAYMENT_STATUS } from '@crescender/calendar/shared';
 * // or from main entry:
 * import { EVENT_TYPES, PAYMENT_STATUS } from '@crescender/calendar';
 * ```
 */

// Export only shared functionality for clean separation
export * from './shared';
